export const onlineModifiyDetailAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }